import React from 'react';

function TestimonialsBrand() {
    return (
        <div>
            <div className="testimonial-with-brand bg-1 bg_image">
                {/* Testimonial Area */}
                <div className="testimonial-brand-area tmp-section-gapTop">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="testimonials-button-area">
                                    <div className="section-head text-align-left">
                                        <div className="section-sub-title">
                                            <img
                                                src="assets/images/services/section-custom-menubar.png"
                                                alt="Corporate_service"
                                            />
                                            <span className="subtitle">Managing Partner’s Message</span>
                                        </div>
                                        <h2 className="title split-collab">
                                            Message from the Managing Partner
                                        </h2>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Paragraph-style testimonials */}
                        <div className="row tmp-section-gapBottom">
                            {/* First testimonial */}
                            <div className="col-lg-6 mb-4">
                                <div className="single-card card-horizontal">
                                    <div className="card-inner">
                                        <div className="content">
                                            <p style={{ textAlign: 'justify' }}>
                                                At AQ Auditing, we’re a passionate and forward-thinking team driven
                                                by a fresh approach to problem-solving and execution. We believe
                                                success isn’t just about doing different things it’s about doing
                                                things with clarity, intention, and professionalism.
                                                <br/>
                                                <br/>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Second testimonial */}
                            <div className="col-lg-6 mb-4">
                                <div className="single-card card-horizontal">
                                    <div className="card-inner">
                                        <div className="content">
                                            <p style={{ textAlign: 'justify' }}>
                                                In today’s competitive and fast-changing environment, making the most
                                                of your resources is no longer optional it’s essential. That’s
                                                where we come in. With expert guidance, we help businesses sharpen
                                                their focus, strengthen their foundation, and grow with confidence.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Third testimonial centered */}
                            <div className="col-lg-8 offset-lg-2 mb-4">
                                <div className="single-card card-horizontal">
                                    <div className="card-inner">
                                        <div className="content">
                                            <p style={{ textAlign: 'justify' }}>
                                                Our experience with SMEs in Bahrain has shown that many businesses
                                                with great potential are held back not by lack of effort, but by the
                                                absence of strategic direction and structured support. Often, a small
                                                shift in processes, team structure, or financial planning can create a
                                                huge leap forward.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
}

export default TestimonialsBrand;
